'use strict';

var react = require('react');
var PropTypes = require('@userzoomlibraries/toolkit-js-utils/prop-types');
var useComparePrevious = require('./use-compare-previous.js');
require('@userzoomlibraries/toolkit-js-utils/is-equal');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultCompat(PropTypes);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useProps = function useProps(props) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$excluded = _ref.excluded,
      excluded = _ref$excluded === void 0 ? [] : _ref$excluded;

  return react.useMemo(function () {
    var patternExcluded = excluded.filter(function (each) {
      return each.includes('*');
    });
    var literalExcluded = excluded.filter(function (each) {
      return !each.includes('*');
    });
    var propsToUse = Object.keys(props).filter(function (propName) {
      return !literalExcluded.includes(propName);
    }).filter(function (propName) {
      return patternExcluded.every(function (eachPattern) {
        var patternStringWithoutAsterisk = eachPattern.replace(/\*/g, '');
        return !propName.includes(patternStringWithoutAsterisk);
      });
    }).reduce(function (accumulator, currentPropName) {
      return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, currentPropName, props[currentPropName]));
    }, {});
    return propsToUse;
  }, useComparePrevious([props]));
};

useProps.HOOK_ID = 'Gearz.ReactHooks.useProps';
useProps.returnType = PropTypes__default["default"].objectWithDescription('Object with key/value of props.');
useProps.parameterTypes = {
  props: PropTypes__default["default"].objectWithDescription('Props of the component.').isRequired,
  options: PropTypes__default["default"].shapeWithDescription({
    excluded: PropTypes__default["default"].arrayOfWithDescription(PropTypes__default["default"].string, 'Array of names of props to be excluded. You can pass names like: "aria-*" to exclude all the aria props.')
  }, 'Options of useProps.')
};
useProps.defaultParameters = {
  options: {
    excluded: []
  }
};

module.exports = useProps;
